/****************************************************
 * Module Name:  addUsersettingsModalWrapper.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import AddUsersettingsModal from "./addUsersettingsModal";
import UsersettingsProxy from "../../utility/proxy/manager/usersettingsProxy";
import CommonSnackbar from "../common/commonSnackBar";
import { Box } from "@mui/material";
import Constants from "../../utility/constants";

export default class addUsersettingsModalWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: this.props.loadData && this.props.username,
      sourceData: this.props.sourceData,
      errorSnackbar: false,
      loadingButton: false,
    };

    if (this.props.loadData && this.props.username) {
      UsersettingsProxy.GetSingleUsersettingsDetailByUserName(
        this.props.username,
        (responseData) =>
          this.setState({ showLoading: false, sourceData: responseData })
      );
    }
  }

  handleValidation = (usersettingsData) => {
    //TODO do validation if needed here
    return true;
  };

  handleSave = (usersettingsData) => {
    //Updating Usersettings, and once usersettings is updated on call refresh the list of current usersettings
    this.setState({ loadingButton: true });
    UsersettingsProxy.UpdateUsersettings(usersettingsData, (response) => {
      if (response) {
        this.setState({ loadingButton: false });
        //Hidding usersettings modal
        this.props.handleClose();
      } else {
        this.setState({
          errorSnackbar: true,
        });
      }
    });
  };

  render() {
    return (
      <div>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        {this.state.showLoading ? (
          <CommonSnackbar
            show={true}
            message={
              <Box>
                <Spinner size="lg" animation="border" /> &nbsp;&nbsp; Loading...{" "}
              </Box>
            }
            variant={"info"}
            autoHide={false}
            handleClose={this.props.handleClose}
            title="Retrieving User Settings"
          />
        ) : (
          <AddUsersettingsModal
            Show={true}
            handleClose={this.props.handleClose}
            handleSave={this.handleSave}
            handleValidation={this.handleValidation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        )}
      </div>
    );
  }
}
